"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EyeClosedIcon = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const IconContainer_1 = __importDefault(require("./IconContainer"));
const EyeClosedIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (react_1.default.createElement(IconContainer_1.default, Object.assign({ className: (0, classnames_1.default)("gerudo-icon-eye-closed", size, className) }, props),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.0", viewBox: "0 0 24 22.627", role: "img", "aria-label": title },
            react_1.default.createElement("title", null, title),
            react_1.default.createElement("path", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", fill: "currentColor", d: "M11.983,18.125A6.14,6.14,0,0,1,6.5,9.212L3.587,6.3A13.329,13.329,0,0,0,.4,10.315a3.617,3.617,0,0,0,0,3.323A13.04,13.04,0,0,0,11.983,20.76a12.816,12.816,0,0,0,5.031-1.029l-2.267-2.268A6.114,6.114,0,0,1,11.983,18.125Z", role: "presentation" }),
            react_1.default.createElement("path", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", fill: "currentColor", d: "M23.658,13.446a3.328,3.328,0,0,0,0-2.939A13.046,13.046,0,0,0,11.983,3.193,12.8,12.8,0,0,0,6.976,4.212L2.763,0,1.349,1.414,22.562,22.627l1.415-1.414L20.4,17.631A13.277,13.277,0,0,0,23.658,13.446ZM11.983,5.828a6.137,6.137,0,0,1,5.5,8.888l-2.052-2.052a3.457,3.457,0,0,0,.068-.687,3.513,3.513,0,0,0-4.2-3.446L9.243,6.479A6.1,6.1,0,0,1,11.983,5.828Z", role: "presentation" }),
            react_1.default.createElement("path", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", fill: "currentColor", d: "M12.7,15.416,8.543,11.26A3.513,3.513,0,0,0,12.7,15.416Z", role: "presentation" }))));
};
exports.EyeClosedIcon = EyeClosedIcon;
EyeClosedIcon.defaultProps = {
    title: "Eye closed",
};
exports.default = EyeClosedIcon;
//# sourceMappingURL=EyeClosed.js.map